import { createTheme } from '@mui/material/styles';

// RoboJackets Brand Colors
const robojacketsColors = {
  teal: '#009494',
  darkTeal: '#004343',
  white: '#FFFFFF',
  black: '#212121',
  gray: '#949494',
  accentHighlight: '#94e3e3',
};

export const robojacketsTheme = createTheme({
  palette: {
    primary: {
      main: robojacketsColors.teal,
      dark: robojacketsColors.darkTeal,
      light: robojacketsColors.accentHighlight,
      contrastText: robojacketsColors.white,
    },
    secondary: {
      main: robojacketsColors.darkTeal,
      light: robojacketsColors.gray,
      contrastText: robojacketsColors.white,
    },
    text: {
      primary: robojacketsColors.black,
      secondary: robojacketsColors.gray,
    },
    background: {
      default: robojacketsColors.white,
      paper: robojacketsColors.white,
    },
    divider: robojacketsColors.gray,
  },
  typography: {
    fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 900, // Black
      color: robojacketsColors.black,
    },
    h2: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 700, // Bold
      color: robojacketsColors.black,
    },
    h3: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 700, // Bold
      color: robojacketsColors.black,
    },
    h4: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600, // Normal
      color: robojacketsColors.black,
    },
    h5: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600, // Normal
      color: robojacketsColors.black,
    },
    h6: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600, // Normal
      color: robojacketsColors.black,
    },
    body1: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 300, // Light
      color: robojacketsColors.black,
    },
    body2: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 300, // Light
      color: robojacketsColors.black,
    },
    button: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600, // Normal
      textTransform: 'none',
    },
    caption: {
      fontFamily: '"Nunito Sans", "Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: 600, // Normal
      color: robojacketsColors.gray,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '10px 24px',
          fontWeight: 600,
        },
        contained: {
          backgroundColor: robojacketsColors.teal,
          color: robojacketsColors.white,
          '&:hover': {
            backgroundColor: robojacketsColors.darkTeal,
          },
        },
        outlined: {
          borderColor: robojacketsColors.teal,
          color: robojacketsColors.teal,
          '&:hover': {
            backgroundColor: robojacketsColors.teal,
            color: robojacketsColors.white,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 12px rgba(0, 148, 148, 0.1)',
          border: `1px solid ${robojacketsColors.accentHighlight}`,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: robojacketsColors.teal,
          color: robojacketsColors.white,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: robojacketsColors.gray,
            },
            '&:hover fieldset': {
              borderColor: robojacketsColors.teal,
            },
            '&.Mui-focused fieldset': {
              borderColor: robojacketsColors.teal,
            },
          },
        },
      },
    },
  },
});

export default robojacketsTheme; 